'use client';

import styled from '@emotion/styled';
import { LoadingButton } from '@epos/ui';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { logoutAction } from '@/app/[subdomain]/(main)/_components/account-menu/logout-action';
import { setUser } from '@/store';

export const LOGOUT_LABEL = 'Logout';

const StyledLoadingButton = styled(LoadingButton)`
  --btn-Color: ${({ theme }) => theme.vars.palette.error.main};
  width: 100%;
  font-size: 0.875rem;
  line-height: 1.125rem;
  font-weight: 400;
  justify-content: flex-start;
  padding: ${({ theme }) => theme.spacing(1)};
  height: auto;
  &:hover {
    background-color: ${({ theme }) => theme.palette.action.hover};
  }
`;

const LogoutOption: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const handleLogout = useCallback(async () => {
    setIsLoading(true);
    try {
      await logoutAction();
      dispatch(setUser(undefined));
    } catch {
      setIsLoading(false);
    }
  }, []);

  return (
    <StyledLoadingButton
      onClick={handleLogout}
      className='!text-error-30'
      loading={isLoading}
      variant='text'
      spinnerWidth='16'
    >
      <span>{LOGOUT_LABEL}</span>
    </StyledLoadingButton>
  );
};

export default LogoutOption;
